import React from 'react';

const HistoryItem = ({transaction, id, delTransaction}) => (
  <li 
    className={`history__item ${transaction.add 
      ? 'history__item-plus' 
      : 'history__item-minus'}`}>
    {transaction.description}
    <span className="history__money" data-id={id}>{
      `${transaction.add ? '+' : '-'}`}{transaction.amount} ₽</span>
    <button 
      className="history__delete" 
      onClick={() => {
          delTransaction(transaction.id);
          console.log('delTransaction transaction.id: ', transaction.id);
        }
      }
      >x</button>
  </li>
);

export default HistoryItem;

/*  <span className="history__money">+30000 ₽</span>
    <button className="history__delete">x</button>
 */
/*
<li className="history__item  history__item-minus">
  Отдал долг
  <span className="history__money">-10000 ₽</span>
  <button className="history__delete">x</button>
</li>
*/
